<template>
  <div class="home">
    <div class="topheader">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="list">
            <i class="el-icon-user-solid"></i>
            <div class="listdiv">
              <div>访问量</div>
              <div>100</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="list">
            <i class="el-icon-user-solid"></i>
            <div class="listdiv">
              <div>在线人数</div>
              <div>100</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="list">
            <i class="el-icon-user-solid"></i>
            <div class="listdiv">
              <div>访问量</div>
              <div>100</div>
            </div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="list">
            <i class="el-icon-user-solid"></i>
            <div class="listdiv">
              <div>访问量</div>
              <div>100</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!--  -->
    <div class="middle">
      <div class="leftdiv">12333</div>
      <div class="rightdiv">
        <div class="titles">通知</div>
        <ul>
          <li>阿基咯喀喀喀口袋空空的打开</li>
          <li>阿基咯喀喀喀口袋空空的打开阿基咯喀喀喀口袋空空的打开</li>
          <li>都看到了都得到了溜达溜达溜达了</li>
          <li>都看到了都得到了溜达溜达溜达了</li>
        </ul>
      </div>
    </div>
    <!--  -->
    <div class="bottom">
      <div class="titles">通知</div>
      <div class="newswrap ">
        <ul class="newlist newlist1">
          <li v-for="item in 3">
            <div class="lidiv lidiv1">
              <div class="imgdiv imgdiv1">
                <img src="../../../static/images/background.jpg" alt="">
              </div>
              <div class="prname">12222</div>
            </div>
          </li>
        </ul>
        <div class="more" >查看更多</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {

  },
  data() {
    return {

    };
  },
  computed: {

  },
  created() {

  },
  methods: {

  },
};
</script>

<style  lang="less">
.home {
  width: 1200px;
  margin: 0 auto;
  .topheader {
    overflow: hidden;
    margin-top: 20px;
    .list {
      padding: 20px 0;
      text-align: center;
      border-radius: 4px;
      border: 1px solid #ebeef5;
      background-color: #fff;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
      i {
        font-size: 40px;
        color: #449ce2;
      }
      .listdiv {
        div {
          &:last-child {
          }
        }
      }
    }
  }
  .middle {
    margin-top: 20px;
    overflow: hidden;
    .leftdiv {
      float: left;
      width: 30%;
      height: 200px;
      background: #f5f5f5;
    }
    .rightdiv {
      float: left;
      width: 70%;
      box-sizing: border-box;
      padding-left: 20px;

      ul {
        li {
          padding: 10px 0;
          border-bottom: 1px solid #f5f5f5;
        }
      }
    }
  }
  .bottom {
    overflow: hidden;
    margin-top: 20px;
    .leftdiv {
      float: left;
      width: 30%;
      height: 200px;
      background: #f5f5f5;
    }
    .newswrap {
      width: 1200px;
      box-sizing: border-box;
      background: #f9f9f9;
      padding: 20px;
      margin: 0 auto;
    }
    .newswrap1 {
    }
    .newlist {
      overflow: hidden;
    }

    .newlist li {
      width: 25%;
      float: left;
    }
    .newlist1 li {
      width: 33.33%;
      float: left;
    }
    .lidiv {
      cursor: pointer;
      margin: 0 15px;
      background: #fff;
      height: 300px;
    }
    .lidiv1 {
      height: auto;
    }
    .imgdiv {
      width: 100%;
      height: 180px;
      overflow: hidden;
      position: relative;
    }
    .imgdiv1 {
      height: 200px;
    }
    .imgdiv img {
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      width: 100%;
      height: 100%;
    }
  }
  .titles {
    color: #449ce2;
    font-size: 16px;
    font-weight: bold;
    height: 30px;
    line-height: 30px;
    border-left: 3px solid #449ce2;
    padding-left: 10px;
    margin-bottom: 10px;
  }
  .prname {
    text-align: center;
    font-size: 16px;
    padding: 12px;
    color: #2a2a2a;
  }
  .more {
  text-align: right;
  padding: 14px;
  font-size: 14px;
  color: #449ce2;
  cursor: pointer;
}
}
</style>



// WEBPACK FOOTER //
// src/components/Home/index.vue